import React, {useCallback, useEffect, useState} from 'react';
import {Dropdown} from "semantic-ui-react";
import './styles.scss';
import {apiPost} from "../../services/apiClient";
import {toast} from "react-toastify";
import throttle from 'lodash.throttle';

const InitiatorSearchDropdown = (
    {
        className,
        name,
        value,
        disabled,
        onChange,
        placeholder,
        error
    }
) => {
    const [options, setOptions] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);

    const searchDataFunc = (text) => {
        if (!text || text.trim() === '') {
            setOptions([]);
            return;
        }

        apiPost('admin/companies/ref/users/search', { 
            searchText: text || ''
        }).then(data => {
            const serverItems = (data.entries || []).map(user => ({
                key: user.id,
                value: user.id,
                text: `${user.fullName} (${user.login})`,
                data: { 
                    id: user.id,
                    login: user.login,
                    fullName: user.fullName
                }
            }));
            
            setOptions(serverItems);
        }).catch((e) => {
            console.log('Ошибка поиска инициаторов:', e);
            setOptions([]);
        });
    };

    const searchData = useCallback(throttle(searchDataFunc, 600), []);

    const onChangeValue = (e, {value: selectedValue}) => {
        if (!selectedValue) {
            onChange(name, null);
            setSearchQuery('');
            setSelectedUser(null);
            return;
        }
        
        // Находим выбранный элемент в текущих опциях
        const selected = options.find(opt => opt.value === selectedValue);
        if (selected && selected.data) {
            setSelectedUser(selected);
            onChange(name, selectedValue);
            setSearchQuery(`${selected.data.fullName} (${selected.data.login})`);
        } else {
            // Если не нашли в опциях, просто устанавливаем значение
            onChange(name, selectedValue);
        }
    };

    // Загружаем данные для отображения выбранного пользователя при изменении value
    useEffect(() => {
        if (value && !selectedUser) {
            // Если есть значение, но нет выбранного пользователя, 
            // делаем поиск по пустой строке, чтобы получить список и найти нужного
            // Или можно сделать отдельный запрос для получения пользователя по ID
            // Пока оставляем пустым - пользователь увидит ID, но это лучше чем ничего
            setSearchQuery('');
        } else if (!value) {
            setSelectedUser(null);
            setSearchQuery('');
        }
    }, [value, selectedUser]);

    useEffect(() => {
        if (searchQuery && searchQuery.trim() !== '') {
            const expectedDisplayText = selectedUser ? `${selectedUser.data.fullName} (${selectedUser.data.login})` : '';
            // Запускаем поиск только если поисковый запрос отличается от отображаемого текста выбранного пользователя
            if (searchQuery !== expectedDisplayText) {
                searchData(searchQuery);
            }
        } else {
            setOptions([]);
        }
    }, [searchQuery]);

    // Загружаем начальные данные при фокусе, если нет поискового запроса
    const handleFocus = () => {
        if (!searchQuery || searchQuery.trim() === '') {
            // При фокусе не загружаем данные, ждем ввода пользователя
        }
    };

    return (
        <div style={{ position: 'relative' }}>
            <Dropdown
                error={error}
                className={`selection input-dropdown ${className || ''}`}
                placeholder={placeholder || 'Введите логин для поиска'}
                fluid
                selection
                name={name}
                search={() => options}
                searchQuery={searchQuery}
                onSearchChange={(e, {searchQuery: newQuery}) => {
                    setSearchQuery(newQuery);
                    if (newQuery && newQuery.trim() !== '') {
                        searchData(newQuery);
                    } else {
                        setOptions([]);
                    }
                }}
                onFocus={handleFocus}
                disabled={disabled}
                options={options}
                value={value || null}
                noResultsMessage={'Введите логин для поиска'}
                onChange={onChangeValue}
                selectOnNavigation={false}
                selectOnBlur={false}
                allowAdditions={false}
                onBlur={() => {
                    // Восстанавливаем значение выбранного пользователя
                    if (selectedUser) {
                        setSearchQuery(`${selectedUser.data.fullName} (${selectedUser.data.login})`);
                    } else if (!value) {
                        setSearchQuery('');
                    }
                }}
                style={{ position: 'relative' }}
            />
            {/* Собственный крестик */}
            {value && (
                <div
                    style={{
                        position: 'absolute',
                        right: '0.5em',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 1000,
                        cursor: 'pointer',
                        color: '#999',
                        fontSize: '18px',
                        fontWeight: '300',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'transparent',
                        border: 'none',
                        userSelect: 'none'
                    }}
                    onClick={() => {
                        onChange(name, null);
                        setSearchQuery('');
                        setSelectedUser(null);
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.color = '#666';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.color = '#999';
                    }}
                >
                    ×
                </div>
            )}
        </div>
    );
};

export default InitiatorSearchDropdown;



// WEBPACK FOOTER //
// ./App/components/Dropdowns/InitiatorSearchDropdown.jsx